import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, AfterViewInit } from '@angular/core';
import { AngularMaterialService, ErrorParseService, IPaymentCheck } from '../../commons';
import { Store } from '@ngrx/store';

import { SelectionModel } from '@angular/cdk/collections';
import * as fromPaymentCheck from './state/payment-check.selectors';
import * as PaymentCheckAction from './state/payment-check.actions';
import * as lgeApp from '../../app/state/app.actions';
import * as _ from 'lodash';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, skipWhile, Subscription } from 'rxjs';
import { slideInDownAnimation } from 'src/app/app.animation';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'payment-check-screen',
    templateUrl: 'payment-check.component.html',
    styleUrls: ['payment-check.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class PaymentCheckScreenComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() pending$: Observable<boolean>;
    pendingSubscription: Subscription;
    pending: boolean;

    @Input() error$: Observable<string | null>;
    errorSubscription: Subscription;
    error: string | null;

    @Input() pendingValidateCCData$: Observable<IPaymentCheck | null>;
    pendingValidateCCDataSubscription: Subscription;

    @Input() forUploadCCData$: Observable<IPaymentCheck | null>;
    forUploadCCDataSubscription: Subscription;

    @Input() sentOeBSCCData$: Observable<IPaymentCheck | null>;
    sentOeBSCCDataSubscription: Subscription;

    @Input() pendingValidateCGData$: Observable<IPaymentCheck | null>;
    pendingValidateCGDataSubscription: Subscription;

    @Input() forUploadCGData$: Observable<IPaymentCheck | null>;
    forUploadCGDataSubscription: Subscription;

    @Input() sentOeBSCGData$: Observable<IPaymentCheck | null>;
    sentOeBSCGDataSubscription: Subscription;

    @Input() pendingValidatePPData$: Observable<IPaymentCheck | null>;
    pendingValidatePPDataSubscription: Subscription;

    @Input() forUploadPPData$: Observable<IPaymentCheck | null>;
    forUploadPPDataSubscription: Subscription;

    @Input() sentOeBSPPData$: Observable<IPaymentCheck | null>;
    sentOeBSPPDataSubscription: Subscription;

    @Input() pendingValidateESData$: Observable<IPaymentCheck | null>;
    pendingValidateESDataSubscription: Subscription;

    @Input() forUploadESData$: Observable<IPaymentCheck | null>;
    forUploadESDataSubscription: Subscription;

    @Input() sentOeBSESData$: Observable<IPaymentCheck | null>;
    sentOeBSESDataSubscription: Subscription;

    @ViewChild('tabGroupGrants') tabGroupGrants;

    isNullFormCCDetails = false;
    isLoadingFormCCDetails = false;
    showErrorFormCCDetails = false;
    errorMessageFormCCDetails: string;

    formCCDetails = [];
    formCCUploadDetails = [];
    formCCSentToOeBSDetails = [];

    formCGDetails = [];
    formCGUploadDetails = [];
    formCGSentToOeBSDetails = [];

    formPPDetails = [];
    formPPUploadDetails = [];
    formPPSentToOeBSDetails = [];

    formESDetails = [];
    formESUploadDetails = [];
    formESSentToOeBSDetails = [];

    dataSource: MatTableDataSource<any>;
    selection = new SelectionModel<any>(true, []);

    columnsFormCC = ['select', 'requestNo', 'formCCName', 'OrgInfo.name', 'OrgInfo.subsection_501', 'effdt', 'statusDescr', 'validateStatusCode', 'view'];
    columnsFormCCSentToOEBS = ['requestNo', 'formCCName', 'OrgInfo.name', 'OrgInfo.subsection_501', 'effdt', 'statusDescr', 'OeBSStatus', 'view'];
    
    columnsFormCGPP = ['select', 'requestNo', 'projectName', 'orgInfoName', 'orgInfoSubsection', 'dateRequest', 'statusAdmin', 'validateStatusCode', 'view'];
    columnsFormCGPPSentToOEBS = ['requestNo', 'projectName', 'orgInfoName', 'orgInfoSubsection', 'dateRequest', 'statusAdmin', 'OeBSStatus', 'view'];
    
    columnsFormES = ['select', 'requestNo', 'eventName', 'orgInfoName', 'orgInfoSubsection', 'dateRequest', 'statusAdmin', 'validateStatusCode', 'view'];
    columnsFormESSentToOEBS = ['requestNo', 'eventName', 'orgInfoName', 'orgInfoSubsection', 'dateRequest', 'statusAdmin', 'OeBSStatus', 'view'];

    constructor(
        private store: Store<fromPaymentCheck.State>,
        private ref: ChangeDetectorRef,
        private ams: AngularMaterialService,
        private errorParse: ErrorParseService,
        private toast: ToastrService,
    ) {
        this.selectState();
        this.dataSource = new MatTableDataSource([]);
    }

    ngOnInit() {
        this.startSubscriptions();
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.store.dispatch(new PaymentCheckAction.LoadFormCCForValidateInvoiveState());
            this.store.dispatch(new PaymentCheckAction.LoadFormCCForUploadState());
            this.store.dispatch(new PaymentCheckAction.LoadFormCCSentToOeBSState());

            this.store.dispatch(new PaymentCheckAction.LoadFormCGForValidateInvoiveState());
            this.store.dispatch(new PaymentCheckAction.LoadFormCGForUploadState());
            this.store.dispatch(new PaymentCheckAction.LoadFormCGSentToOeBSState());

            this.store.dispatch(new PaymentCheckAction.LoadFormPPForValidateInvoiveState());
            this.store.dispatch(new PaymentCheckAction.LoadFormPPForUploadState());
            this.store.dispatch(new PaymentCheckAction.LoadFormPPSentToOeBSState());

            this.store.dispatch(new PaymentCheckAction.LoadFormESForValidateInvoiveState());
            this.store.dispatch(new PaymentCheckAction.LoadFormESForUploadState());
            this.store.dispatch(new PaymentCheckAction.LoadFormESSentToOeBSState());

            // this.store.dispatch(new PaymentCheckAction.LoadFormCIForValidateInvoiveState());
            // this.store.dispatch(new PaymentCheckAction.LoadFormCIForUploadState());
            // this.store.dispatch(new PaymentCheckAction.LoadFormCISentToOeBSState());
        });
    }

    // Select state
    selectState(): void {
        this.pending$ = this.store.select(fromPaymentCheck.getPaymentCheckScreenPending);
        this.error$ = this.store.select(fromPaymentCheck.getPaymentCheckScreenError).pipe(skipWhile(error => error === undefined || error === null || error === ''));

        this.pendingValidateCCData$ = this.store.select(fromPaymentCheck.getFormCCForValidateState).pipe(skipWhile(data => data === undefined || data === null));
        this.forUploadCCData$ = this.store.select(fromPaymentCheck.getFormCCForUploadState).pipe(skipWhile(data => data === undefined || data === null));
        this.sentOeBSCCData$ = this.store.select(fromPaymentCheck.getFormCCSentToOeBSState).pipe(skipWhile(data => data === undefined || data === null));

        this.pendingValidateCGData$ = this.store.select(fromPaymentCheck.getFormCGForValidateState).pipe(skipWhile(data => data === undefined || data === null));
        this.forUploadCGData$ = this.store.select(fromPaymentCheck.getFormCGForUploadState).pipe(skipWhile(data => data === undefined || data === null));
        this.sentOeBSCGData$ = this.store.select(fromPaymentCheck.getFormCGSentToOeBSState).pipe(skipWhile(data => data === undefined || data === null));

        this.pendingValidatePPData$ = this.store.select(fromPaymentCheck.getFormPPForValidateState).pipe(skipWhile(data => data === undefined || data === null));
        this.forUploadPPData$ = this.store.select(fromPaymentCheck.getFormPPForUploadState).pipe(skipWhile(data => data === undefined || data === null));
        this.sentOeBSPPData$ = this.store.select(fromPaymentCheck.getFormPPSentToOeBSState).pipe(skipWhile(data => data === undefined || data === null));

        this.pendingValidateESData$ = this.store.select(fromPaymentCheck.getFormESForValidateState).pipe(skipWhile(data => data === undefined || data === null));
        this.forUploadESData$ = this.store.select(fromPaymentCheck.getFormESForUploadState).pipe(skipWhile(data => data === undefined || data === null));
        this.sentOeBSESData$ = this.store.select(fromPaymentCheck.getFormESSentToOeBSState).pipe(skipWhile(data => data === undefined || data === null));

        // this.pendingValidateCIData$ = this.store.select(fromPaymentCheck.getFormCIForValidateState).pipe(skipWhile(data => data === undefined || data === null));
        // this.forUploadCIData$ = this.store.select(fromPaymentCheck.getFormCIForUploadState).pipe(skipWhile(data => data === undefined || data === null));
        // this.sentOeBSCIData$ = this.store.select(fromPaymentCheck.getFormCISentToOeBSState).pipe(skipWhile(data => data === undefined || data === null));
    }

    displayLoader(pending: boolean): void {
        if (pending) {
            setTimeout(() => {
                this.ams.showLoader('Loading...');
                this.ref.markForCheck();
            })
        } else {
            this.ams.closeDialog().then(() => {
                if (this.error !== null && this.error !== undefined && this.error !== '') {
                    this.displayError(this.error);
                }
            });
        }
    }

    displayError(error: any): void {
        let errorMessage;
        if (this.errorParse.foundKeyWord(error, 'CORPCOMMONWS')) {
            errorMessage = this.errorParse.translateCCError(error);
        } else {
            errorMessage = error instanceof Object ? error.message : error;
        }

        if (errorMessage.includes('Successfully'))
            this.ams.showAlert("Success!", errorMessage);
        else if (errorMessage.includes('failed to upload'))
            this.ams.showAlert("Failed to upload!", errorMessage);
        else if (errorMessage.includes('failed to validate'))
            this.ams.showAlert("Failed to validate!", errorMessage);
        else
            this.ams.showAlert("Error", errorMessage);

        this.ams.alert.afterClosed().subscribe(result => {
            this.store.dispatch(new PaymentCheckAction.PaymentCheckScreenErrorReset());
            this.ams.closeDialog();
            this.ref.markForCheck();
        });
    }

    public openSidenav(): void {
        this.store.dispatch(new lgeApp.OpenSidenav());
    }

    startSubscriptions(): void {
        this.pendingSubscription = this.pending$
            .subscribe(data => {
                this.pending = data;
                this.displayLoader(this.pending);
                this.ref.markForCheck();
            });

        this.errorSubscription = this.error$
            .subscribe(data => {
                this.error = data;
                this.ref.markForCheck();
            });

        this.pendingValidateCCDataSubscription = this.pendingValidateCCData$
            .subscribe(rawData => {
                let data = JSON.parse(JSON.stringify(rawData));
                this.formCCDetails = data;
                this.ref.markForCheck();
            });

        this.forUploadCCDataSubscription = this.forUploadCCData$
            .subscribe(rawData => {
                let data = JSON.parse(JSON.stringify(rawData));
                this.formCCUploadDetails = data;
                this.ref.markForCheck();
            })

        this.sentOeBSCCDataSubscription = this.sentOeBSCCData$
            .subscribe(rawData => {
                let data = JSON.parse(JSON.stringify(rawData));
                data.map((obj) => {
                    obj.OeBSStatus = '';
                    return obj;
                })
                data.map((value) => {
                    if (value.statusDescr === 'Sent To Oracle') {
                        value.statusDescr = 'Sent To Oracle';
                        value.OeBSStatus = 'Sent To Oracle';
                    }
                    return value;
                });
                data.map((value) => {
                    if (value.statusDescr === 'Reconciled') {
                        value.statusDescr = 'Check Cashed';
                        value.OeBSStatus = 'Reconciled';
                    }
                    return value;
                });
                data.map((value) => {
                    if (value.statusDescr === 'Negotiable') {
                        value.statusDescr = 'Check Issued';
                        value.OeBSStatus = 'Negotiable';
                    }
                    return value;
                });
                data.map((value) => {
                    if (value.statusDescr === 'Voided') {
                        value.statusDescr = 'Check Voided';
                        value.statusDescr = 'Check Voided';
                        value.OeBSStatus = 'Voided';
                    }
                    return value;
                });
                data.map((value) => {
                    if (value.statusDescr === 'Cleared') {
                        value.statusDescr = 'Check Cleared';
                        value.OeBSStatus = 'Cleared';
                    }
                    return value;
                });
                this.formCCSentToOeBSDetails = data;
                this.ref.markForCheck();
            });

        this.pendingValidateCGDataSubscription = this.pendingValidateCGData$
            .subscribe(rawData => {
                let data = JSON.parse(JSON.stringify(rawData));
                this.formCGDetails = data.reverse();
                this.ref.markForCheck();
            });

        this.forUploadCGDataSubscription = this.forUploadCGData$
            .subscribe(rawData => {
                let data = JSON.parse(JSON.stringify(rawData));
                this.formCGUploadDetails = data.reverse();
                this.ref.markForCheck();
            })

        this.sentOeBSCGDataSubscription = this.sentOeBSCGData$
            .subscribe(rawData => {
                let data = JSON.parse(JSON.stringify(rawData));
                data.map((obj) => {
                    obj.OeBSStatus = '';
                    return obj;
                })
                data.map((value) => {
                    if (value.statusAdmin === 'Sent To Oracle') {
                        value.statusAdmin = 'Sent To Oracle';
                        value.OeBSStatus = 'Sent To Oracle';
                    }
                    return value;
                });
                data.map((value) => {
                    if (value.statusAdmin === 'Reconciled') {
                        value.statusAdmin = 'Check Cashed';
                        value.OeBSStatus = 'Reconciled';
                    }
                    return value;
                });
                data.map((value) => {
                    if (value.statusAdmin === 'Negotiable') {
                        value.statusAdmin = 'Check Issued';
                        value.OeBSStatus = 'Negotiable';
                    }
                    return value;
                });
                data.map((value) => {
                    if (value.statusAdmin === 'Voided') {
                        value.statusAdmin = 'Check Voided';
                        value.OeBSStatus = 'Voided';
                    }
                    return value;
                });
                data.map((value) => {
                    if (value.statusAdmin === 'Cleared') {
                        value.statusAdmin = 'Check Cleared';
                        value.OeBSStatus = 'Cleared';
                    }
                    return value;
                });
                this.formCGSentToOeBSDetails = data.reverse();
                this.ref.markForCheck();
            });

        this.pendingValidatePPDataSubscription = this.pendingValidatePPData$
            .subscribe(rawData => {
                let data = JSON.parse(JSON.stringify(rawData));
                this.formPPDetails = data.reverse();
                this.ref.markForCheck();
            });

        this.forUploadPPDataSubscription = this.forUploadPPData$
            .subscribe(rawData => {
                let data = JSON.parse(JSON.stringify(rawData));
                this.formPPUploadDetails = data.reverse();
                this.ref.markForCheck();
            })

        this.sentOeBSPPDataSubscription = this.sentOeBSPPData$
            .subscribe(rawData => {
                let data = JSON.parse(JSON.stringify(rawData));
                data.map((obj) => {
                    obj.OeBSStatus = '';
                    return obj;
                })
                data.map((value) => {
                    if (value.statusAdmin === 'Sent To Oracle') {
                        value.statusAdmin = 'Sent To Oracle';
                        value.OeBSStatus = 'Sent To Oracle';
                    }
                    return value;
                });
                data.map((value) => {
                    if (value.statusAdmin === 'Reconciled') {
                        value.statusAdmin = 'Check Cashed';
                        value.OeBSStatus = 'Reconciled';
                    }
                    return value;
                });
                data.map((value) => {
                    if (value.statusAdmin === 'Negotiable') {
                        value.statusAdmin = 'Check Issued';
                        value.OeBSStatus = 'Negotiable';
                    }
                    return value;
                });
                data.map((value) => {
                    if (value.statusAdmin === 'Voided') {
                        value.statusAdmin = 'Check Voided';
                        value.OeBSStatus = 'Voided';
                    }
                    return value;
                });
                data.map((value) => {
                    if (value.statusAdmin === 'Cleared') {
                        value.statusAdmin = 'Check Cleared';
                        value.OeBSStatus = 'Cleared';
                    }
                    return value;
                });
                this.formPPSentToOeBSDetails = data.reverse();
                this.ref.markForCheck();
            });


        this.pendingValidateESDataSubscription = this.pendingValidateESData$
            .subscribe(rawData => {
                let data = JSON.parse(JSON.stringify(rawData));
                this.formESDetails = data.reverse();
                this.ref.markForCheck();
            });

        this.forUploadESDataSubscription = this.forUploadESData$
            .subscribe(rawData => {
                let data = JSON.parse(JSON.stringify(rawData));
                this.formESUploadDetails = data.reverse();
                this.ref.markForCheck();
            })

        this.sentOeBSESDataSubscription = this.sentOeBSESData$
            .subscribe(rawData => {
                let data = JSON.parse(JSON.stringify(rawData));
                data.map((obj) => {
                    obj.OeBSStatus = '';
                    return obj;
                })
                data.map((value) => {
                    if (value.statusAdmin === 'Sent To Oracle') {
                        value.statusAdmin = 'Sent To Oracle';
                        value.OeBSStatus = 'Sent To Oracle';
                    }
                    return value;
                });
                data.map((value) => {
                    if (value.statusAdmin === 'Reconciled') {
                        value.statusAdmin = 'Check Cashed';
                        value.OeBSStatus = 'Reconciled';
                    }
                    return value;
                });
                data.map((value) => {
                    if (value.statusAdmin === 'Negotiable') {
                        value.statusAdmin = 'Check Issued';
                        value.OeBSStatus = 'Negotiable';
                    }
                    return value;
                });
                data.map((value) => {
                    if (value.statusAdmin === 'Voided') {
                        value.statusAdmin = 'Check Voided';
                        value.OeBSStatus = 'Voided';
                    }
                    return value;
                });
                data.map((value) => {
                    if (value.statusAdmin === 'Cleared') {
                        value.statusAdmin = 'Check Cleared';
                        value.OeBSStatus = 'Cleared';
                    }
                    return value;
                });
                this.formESSentToOeBSDetails = data.reverse();
                this.ref.markForCheck();
            });

    }

    endSubscriptions(): void {
        this.pendingSubscription.unsubscribe();
        this.errorSubscription.unsubscribe();

        this.pendingValidateCCDataSubscription.unsubscribe();
        this.forUploadCCDataSubscription.unsubscribe();
        this.sentOeBSCCDataSubscription.unsubscribe();

        this.pendingValidateCGDataSubscription.unsubscribe();
        this.forUploadCGDataSubscription.unsubscribe();
        this.sentOeBSCGDataSubscription.unsubscribe();

        this.pendingValidatePPDataSubscription.unsubscribe();
        this.forUploadPPDataSubscription.unsubscribe();
        this.sentOeBSPPDataSubscription.unsubscribe();

        this.pendingValidateESDataSubscription.unsubscribe();
        this.forUploadESDataSubscription.unsubscribe();
        this.sentOeBSESDataSubscription.unsubscribe();

        this.store.dispatch(new PaymentCheckAction.LoadInitPaymentCheckState());
        // this.pendingValidateCIDataSubscription.unsubscribe();
        // this.forUploadCIDataSubscription.unsubscribe();
        // this.sentOeBSCIDataSubscription.unsubscribe();
    }

    ngOnDestroy() {
        this.endSubscriptions();
    }

}


